import React, { useEffect, useState, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Breadcrumb, MenuAccount, WideCardPaymentHistory } from '../../components/Main'
import { InteractorPaymentSearch, InteractorCsvPayment } from '../../interactors/Main'
import { useSelector } from 'react-redux'
import { defaultValueDownloadCSV, maxLimitExport } from '../../constant/global/validation'

const PaymentHistory = () => {
  const { t } = useTranslation()
  const queryParams = new URLSearchParams(window.location.search)
  const { account } = useSelector((state) => state.account)
  const { paymentSearch } = InteractorPaymentSearch()
  const { csvPayment } = InteractorCsvPayment()
  const [loading, setLoading] = useState(true)
  const [loadingCSV, setLoadingCSV] = useState(false)
  const [download, setDownload] = useState(defaultValueDownloadCSV)
  const [datacard, setDatacard] = useState([])
  const [payload, setPayload] = useState({
    page: 1,
    limit: 5,
    keywords: {
      text_search: queryParams.get('ref') ?? '',
      status: '',
      account_uid: account.uid,
      store_uid: '',
    },
  })

  const handleResponse = useCallback((data) => {
    setDatacard(data)
    // csvPayment(data.items, setDownload)
  }, [])

  const handleResponseCSV = useCallback(
    (data) => {
      csvPayment(data?.items, setDownload)
    },
    [csvPayment],
  )

  useEffect(() => {
    if (loading) {
      paymentSearch(payload, handleResponse, setLoading)
    }
  }, [handleResponse, loading, payload, paymentSearch])

  const handleFilter = (row) => {
    setPayload(row)
    setDatacard([])
    setLoading(true)
  }

  const getDataPayment = () => {
    let payloadCsv = { ...payload }
    payloadCsv.limit = maxLimitExport
    setLoadingCSV(true)
    paymentSearch(payloadCsv, handleResponseCSV, setLoadingCSV)
  }

  return (
    <>
      <Breadcrumb title={t('menu.payment_history')} className="mb-4" />
      <div className="container">
        <div className="row mb-8">
          <MenuAccount />
          <div className="col-xl-9 col-wd-9gdot5">
            <div className="flex-center-between mt-2">
              <h3 className="font-size-20 font-size-20-lg font-weight-bold mb-0">
                {t('menu.payment_history')}
              </h3>
            </div>
            <hr />
            <WideCardPaymentHistory
              loading={loading}
              datacard={datacard}
              payload={payload}
              handleFilter={handleFilter}
              download={download}
              setDownload={setDownload}
              getDataPayment={getDataPayment}
              loadingCSV={loadingCSV}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default PaymentHistory
